export enum PaymentProvider {
	XENDIT = "XENDIT",
}
